<script setup>
import { defineProps, defineExpose, ref, computed, watch } from "vue";
import BarcodeScanner from "./BarcodeScanner.vue";
import useBarcode from "@/composables/useBarcode.ts";
import { vMaska } from "maska/vue"

const props = defineProps({
  config: {
    type: Object,
    default : () => {}
  },
  name: {
    type: String,
    default: '',
  },
  modelValue: {
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isBarcodeAutomatic: {
    type: Boolean,
    default: false,
  },
})

const {
  mask : maskBarcode,
  barcode,
  isValid,
  isInvalid,
  setPrefix,
} = useBarcode(props.config)
barcode.value = props.modelValue

const showScanner = ref(false)
const generateAutomatic = ref(props.isBarcodeAutomatic)
const isAutomaticDisabled = computed(() => barcode.value !== '' && !generateAutomatic.value)

watch(barcode, (value) => {
  if (value !== '') {
    generateAutomatic.value = false
  }
})
watch(generateAutomatic, (value) => {
  if (value === false) {
    barcode.value = '';
  }
})

const onBarcodeScanned = (barcodeScanned) => {
  barcode.value = barcodeScanned.trim();
  showScanner.value = false
}

const cleanBarcode = () => {
  barcode.value = '';
  generateAutomatic.value = false
}

defineExpose({ barcode }) // make sure you expose the bound variable)

</script>
<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <button class="btn btn-outline-secondary" type="button"
              v-on:click.prevent="showScanner = true">
        <i class="fa fa-qrcode"></i>
      </button>
    </div>
    <input
      type="text"
      inputmode="numeric"
      v-maska="{
        mask : generateAutomatic ? null : maskBarcode,
        eager : true,
      }"
      v-model="barcode"
      :disabled="disabled || generateAutomatic"
      :class="[
        'form-control',
        !generateAutomatic && isInvalid ? 'is-invalid' : '',
        !generateAutomatic && isValid ? 'is-valid' : '',
      ]"
      autocomplete="off"
      spellcheck="false"
      @focus="setPrefix"
    >
    <!-- ref="el" -->
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" type="button" v-on:click.prevent="cleanBarcode()">
        <i class="fa fa-times-circle"></i>
      </button>
    </div>
  </div>

  <div class="form-check mt-1">
    <input
      type="checkbox"
      class="form-check-input"
      id="frm_participantBarcodeAuto"
      v-model="generateAutomatic"
      :disabled="disabled || isAutomaticDisabled"
    >
    <label class="form-check-label" for="frm_participantBarcodeAuto">
      {{ $t('Automatic barcode') }}
    </label>
  </div>
  <template v-if="!generateAutomatic || barcode !== ''">
    <input type="hidden" :name="name" :value="barcode" v-if="name">
  </template>
  <template v-else>
    <input type="hidden" name="barcodeAuto" value="1">
  </template>

  <BarcodeScanner :show="showScanner"
                   @scan="onBarcodeScanned"
                   @discard="showScanner = false" />
</template>
